export default __webpack_public_path__ + "static/Dashboard-a29ac4c6f23c69899890b9c9b0642480.mp4";